export default __webpack_public_path__ + "static/media/templateInfoLogo_ic.ce3182b9.svg";